import {
    tss,
} from 'app/tss'

export default tss
    .withParams<{ required: boolean, disabled: boolean }>()
    .create(({
        theme,
        required,
        disabled,
    }) => {
        return {
            timePicker: {
                cursor: 'pointer',
                transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                width: '100%',
                whiteSpace: 'nowrap',
                position: 'relative',
                minWidth: 120,
            },
            textField: {
                fontWeight: theme.typography.body1.fontWeight,
                lineHeight: theme.typography.body1.lineHeight,
                color: theme.palette.secondary[900],
                fontSize: theme.typography.body1.fontSize,
                width: '100%',
                margin: 0,
                whiteSpace: 'pre-wrap',
                paddingLeft: theme.spacing(1),
                backgroundColor: (required && !disabled)
                    ? theme.palette.primary[30] : theme.palette.common.white,
            },
            icon: {
                width: '100%',
                height: '100%',
            },
            requiredMark: {
                '&&': {
                    position: 'absolute',
                    left: -6,
                    backgroundColor: theme.palette.primary.main,
                    width: 4,
                    height: '100%',
                    borderRadius: 3,
                },
            },
            input: {
                padding: `${theme.spacing(0.5)} 0 ${theme.spacing(0.25)}`,
            },
        }
    })
